export default __webpack_public_path__ + "static/media/logo1.fa9dd27d.png";